export default /*START_META*/{
  "title": "Submitting Template to the Tradly Marketplace"
}; /*END_META*/